<template>
  <div class="control-panel">
    <round-icon-button
      icon="star"
      size="2x"
      transform="shrink-6 left-0.9"
      v-bind:class="['float-left']"
      :css-classes="[{ favorite: service.favorite }]"
      @click="favoriteServiceClicked"
    />
    <font-awesome-icon
      icon="times"
      size="2x"
      class="float-right control-btn"
      @click="closePanel()"
    />
    <h4 class="mt-1 mb-3">
      {{ placeName }}
      <span
        v-if="isInstaller && place.user_name"
        class="text-small"
      >
        [{{ place.user_name }}]
      </span>
    </h4>
    <service-name-with-editing :service="service" />
    <div role="tablist">
      <status-control-actors
        :service="service"
        class="mb-3"
      />
      <b-button
        block href="#"
        v-b-toggle.accordion-1
        size="lg"
        variant="outline-primary"
        class="mb-3">
        {{ $t('settings') }}
      </b-button>
      <b-collapse
        id="accordion-1"
        accordion="control-panel"
        role="tabpanel"
        @shown="() => { showSettings = true }"
      >
        <loader v-if="!showSettings" />
        <settings-actor
          v-else
          :service="service"
          class="mb-3" />
      </b-collapse>
      <b-button
        block
        v-b-toggle.accordion-2
        size="lg"
        variant="outline-primary"
        class="mb-3">
        {{ $t('logging') }}
      </b-button>
      <b-collapse
        id="accordion-2"
        accordion="control-panel"
        role="tabpanel"
        @shown="() => { showLoggingList = true }"
      >
        <loader v-if="!showLoggingList" />
        <logging-list v-else :service="service" />
      </b-collapse>
      <b-button
        block
        v-b-toggle.accordion-3
        size="lg"
        variant="outline-primary"
        class="mb-3 btn-block"
      >
        {{ $t('notifications') }}
      </b-button>
      <b-collapse
        id="accordion-3"
        accordion="control-panel"
        role="tabpanel"
        @shown="() => { showNotificationsList = true }"
      >
        <loader v-if="!showNotificationsList" />
        <notifications-list v-else :notifications="notifications" />
      </b-collapse>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ControlPanelMixin from '@/mixins/ControlPanel';
import StatusControlActors from '@/components/services/StatusControlActors';
import SettingsActor from '@/components/services/SettingsActor';
import NotificationsList from '@/components/notifications/settings/List';
import LoggingList from '@/components/logging/settings/List';

import { mapGetters, mapActions, mapState } from 'vuex';
import config from '@/config';
import Loader from '@/components/utils/Loader';
import RoundIconButton from '@/components/utils/RoundIconButton';
import ServiceNameWithEditing from '@/components/services/service/ServiceNameWithEditing';

export default {
  name: 'ControlPanel',
  mixins: [ControlPanelMixin],
  props: {
    service: {
      required: true,
    },
  },
  data() {
    return {
      showSettings: false,
      showLoggingList: false,
      showNotificationsList: false,
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters({
      isInstaller: 'user/isUserInstaller',
    }),
    ...mapGetters([
      'getPlaceById',
      'getControlActorsForService',
      'getSettingsActors',
      'getServiceName',
      'getPlaceName',
    ]),
    ...mapGetters('notifications', [
      'getNotificationsByServiceId',
    ]),
    serviceName() {
      return this.getServiceName(this.service.id);
    },
    placeName() {
      return this.getPlaceName(this.service.places[0]);
    },
    place() {
      return this.getPlaceById(this.service.places[0]);
    },
    notifications() {
      return this.getNotificationsByServiceId(this.service.id);
    },
  },
  methods: {
    ...mapActions([
      'setFavoriteService',
    ]),
    favoriteServiceClicked() {
      if (!this.service.favorite) {
        this.setServiceAsFavorite();
      } else {
        this.unsetServiceAsFavorite();
      }
    },
    setServiceAsFavorite() {
      const url = new URL(
        config.ICOOL.API.FAVORITE_OBJECTS_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      const data = {
        content_type: 'service',
        object_id: this.service.id,
      };
      axios.post(url, data).then((response) => {
        this.setFavoriteService({ service: this.service, favorite: true });
      }).catch((error) => {
      }).finally(() => {
      });
    },
    unsetServiceAsFavorite() {
      const url = new URL(
        config.ICOOL.API.FAVORITE_OBJECT_PATH(this.currentSnapshot.id, 'service', this.service.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      axios.delete(url).then((response) => {
        this.setFavoriteService({ service: this.service, favorite: false });
      }).catch((error) => {
      }).finally(() => {
      });
    },
  },
  components: {
    ServiceNameWithEditing,
    RoundIconButton,
    Loader,
    StatusControlActors,
    SettingsActor,
    NotificationsList,
    LoggingList,
  },
};
</script>

<style scoped>
</style>
